<script setup lang="ts">
import { classNames } from '@afinius/utilities/class-names';

interface Props {
  alignItems?: string;
  justifyContent?: string;
  gap?: number;
  width?: string;
  minWidth?: string;
  maxWidth?: string;
  height?: string;
  minHeight?: string;
  maxHeight?: string;
  flex?: string;
  shouldWrap?: boolean;
  shouldFlip?: boolean;
  shouldStack?: boolean;
  shouldStackMobile?: boolean;
  shouldStackReverseMobile?: boolean;
  shouldGrow?: boolean;
  hasBorder?: boolean;
}

withDefaults(defineProps<Props>(), {
  alignItems: undefined,
  justifyContent: undefined,
  gap: 1,
  width: undefined,
  minWidth: undefined,
  maxWidth: undefined,
  height: undefined,
  minHeight: undefined,
  maxHeight: undefined,
  flex: undefined,
});
</script>

<template>
  <div
    class="cluster"
    :class="
      classNames({
        shouldWrap,
        shouldGrow,
        shouldFlip,
        shouldStack,
        shouldStackMobile,
        shouldStackReverseMobile,
        hasBorder,
      })
    "
    :style="{
      alignItems,
      justifyContent,
      gap: hasBorder ? '1px' : `${gap}rem`,
      width,
      minWidth,
      maxWidth,
      height,
      maxHeight,
      minHeight,
      flex,
    }"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use './Cluster.scss';
</style>
